/**
 * BreadcrumbSearchBar
 * 
 * @Author: Focci
 * @Date: 2024-01-16 14:46:23
 * @Last Modified by: Focci
 * @Last Modified time: 2024-01-16 14:46:23
 */

'use client'

import dynamic from 'next/dynamic'
import BreadcrumbSearchTrigger from './BreadcrumbSearchTrigger'

const BreadcrumbSearchBarBody = dynamic(() => import('./BreadcrumbSearchBarBody'), {
  ssr: false,
  loading: () => <BreadcrumbSearchTrigger loading />
})

export default function BreadcrumbSearchBar(props) {
  return (
    <BreadcrumbSearchBarBody {...props} />
  )
}
